import { STATUS } from "@/constant/statusConstants";

export const CompetitionGroupInitialValues = (localeCodes, showData) => ({
  sport_id: showData?.data?.sport?.id || "",
  parent_id: showData?.data?.parent?.id || "",
  code: showData?.data?.code || "",
  localizations: localeCodes.reduce((acc, localeCode) => {
    acc[localeCode] = showData?.data?.localization_contents?.[localeCode] ?? "";
    return acc;
  }, {}),
  icon: null,
  status: showData?.data?.status || STATUS.INACTIVE,
});
